import React, {Component} from 'react';
import {LoadingOverlay} from '@homeaway/react-loading-overlay';
import classNames from 'classnames';
import './style.less';

export class SearchButton extends Component {
    state = {
        disabled: true
    }

    componentDidMount() {
        this.setState({disabled: false});
    }

    render() {
        const {className, label, isLoadingSerp} = this.props;
        return (
            <div className="search__button-container">
                <button
                    type="submit"
                    disabled={this.state.disabled || isLoadingSerp}
                    className={classNames(className, 'search__button btn btn-primary')}
                >
                    {label}
                    <LoadingOverlay loading={isLoadingSerp} />
                </button>
            </div>
        );
    }
}
